import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["date", "rowFilter"]

  dropRowFilter() {
    const forecast = this.element.querySelector('input[name="forecast"]:checked')
    if (!forecast || forecast.value === "external") return

    this.rowFilterTargets.forEach((input) => input.remove())
  }

  toIso() {
    this.element.querySelectorAll("input[data-reports-due-iso]").forEach((node) => node.remove())

    this.dateTargets.forEach((input) => {
      const iso = this.parseToIso(input.value.trim())
      if (!iso) return

      const hidden = document.createElement("input")
      hidden.type = "hidden"
      hidden.name = input.name
      hidden.value = iso
      hidden.setAttribute("data-reports-due-iso", "")
      this.element.appendChild(hidden)

      input.disabled = true
    })
  }

  parseToIso(value) {
    if (!value) return null

    const slash = value.match(/^(\d{1,2})[\/\-.](\d{1,2})[\/\-.](\d{4})$/)
    if (slash) {
      const [, day, month, year] = slash
      return this.iso(year, month, day)
    }

    const ordinal = value.match(/^(\d{1,2})(?:st|nd|rd|th)?\s+([a-zA-Z]{3})\s+(\d{4})$/)
    if (ordinal) {
      const [, day, monthAbbr, year] = ordinal
      const month = this.monthNumber(monthAbbr)
      if (month === null) return null
      return this.iso(year, month, day)
    }

    return null
  }

  iso(year, month, day) {
    const mm = String(month).padStart(2, "0")
    const dd = String(day).padStart(2, "0")
    return `${year}-${mm}-${dd}`
  }

  monthNumber(abbr) {
    const months = {
      jan: 1, feb: 2, mar: 3, apr: 4, may: 5, jun: 6,
      jul: 7, aug: 8, sep: 9, oct: 10, nov: 11, dec: 12,
    }
    const number = months[abbr.toLowerCase()]
    return number === undefined ? null : number
  }
}
